import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import AuthContext from "../context/Authcontext";

const Createroom = () => {
  const { id } = useParams();
  const [room, setroom] = useState({ name: "", description: "" });
  const navigate = useNavigate();
  const { contextData } = useContext(AuthContext);
  const [errorMessage, setErrorMessage] = useState(""); // new state variable for error message

  const handelceateroom = async (e) => {
    e.preventDefault();

    let responce;
    try {
      responce = await axios.post(
        `https://pfebackend-zbz0.onrender.com/api/room/add/`,
        { name: room.name, formation: id, description: room.description },
        {
          headers: {
            Authorization: `Bearer ${contextData.authTokens.access}`,
          },
        }
      );
    } catch (error) {
      if (error.response && error.response.status === 500) {
        setErrorMessage(
          "Sorry, there was a problem with the server. Please try again later."
        );
      }
      return;
    }
    navigate(`/formation/${id}/rooms/${responce.data.id}`);
  };

  useEffect(() => {
    userisinforums();
  }, []);

  const userisinforums = async () => {
    let responce;
    if (contextData.user) {
      try {
        responce = await axios.get(
          `https://pfebackend-zbz0.onrender.com/api/user/formation/${id}/`,
          {
            headers: {
              Authorization: `Bearer ${contextData.authTokens.access}`,
            },
          }
        );
      } catch (error) {
        if (error.response && error.response.status === 500) {
          setErrorMessage(
            "Sorry, there was a problem with the server. Please try again later."
          );
        }
        return;
      }
      if (!responce.data) {
        navigate("/notallowed");
      }
    } else {
      navigate("/notallowed");
    }
  };

  return (
    <div className="forum-creation-container">
      <h2>Create a discussion forum</h2>
      {errorMessage && <div className=" erroremailexiste">{errorMessage}</div>}

      <form onSubmit={handelceateroom}>
        <div className="form-create-name">
          <label className="create-room-lable" htmlFor="name">
            name :{" "}
          </label>
          <input
            className="forum-creation-input"
            type="text"
            name="name"
            id="name"
            value={room.name}
            onChange={(e) => setroom({ ...room, name: e.target.value })}
          />
        </div>

        <div className="form-create-question">
          <label className="create-room-lable" htmlFor="description">
            question
          </label>

          <textarea
            className="create-room-textarea"
            onInput={(e) => setroom({ ...room, description: e.target.value })}
            name="description"
            value={room.description}
            id="description"
          ></textarea>
        </div>

        <button className="btn-create-room" type="submit">
          Create
        </button>
      </form>
    </div>
  );
};

export default Createroom;
